import React from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useReaderState } from '../../lib/readerState';
export function Navbar() {
  const {
    isReading,
    exitReader
  } = useReaderState();
  /**
   * "LOS 12" brand mark behaviour:
   *  - ALWAYS smooth-scrolls to the top of the CURRENT page (home or any
   *    subpage). It never changes routes. This makes it act like the
   *    standard "scroll-to-top" affordance on every page of the site.
   */
  const handleBrandClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <motion.nav initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8
  }} className="fixed top-0 left-0 right-0 z-50 bg-cosmic-black bg-opacity-80 backdrop-blur-sm border-b border-gold-primary border-opacity-20" data-id="element-477">
      <div className="container mx-auto px-4 md:px-6 py-3 md:py-4 flex justify-between items-center gap-3" data-id="element-478">
        <a href="#top" onClick={handleBrandClick} aria-label="Volver al inicio de la página" className="text-2xl md:text-3xl font-serif font-bold text-gold-light tracking-wider hover:text-gold-primary transition-colors flex-shrink-0 cursor-pointer select-none" data-id="element-479">
          LOS 12
        </a>

        <div className="flex items-center gap-2 md:gap-3 min-w-0" data-id="element-480">
          <AnimatePresence data-id="element-481">
            {isReading && <motion.button key="back-to-docs" type="button" onClick={exitReader} initial={{
            opacity: 0,
            x: 10,
            scale: 0.95
          }} animate={{
            opacity: 1,
            x: 0,
            scale: 1
          }} exit={{
            opacity: 0,
            x: 10,
            scale: 0.95
          }} transition={{
            duration: 0.2
          }} className="inline-flex items-center gap-2 rounded-full px-3 md:px-4 py-2 md:py-2.5 text-[10px] md:text-xs font-serif font-semibold tracking-[0.15em] uppercase truncate" style={{
            background: 'rgba(245,240,225,0.1)',
            border: '1px solid rgba(245,240,225,0.5)',
            color: '#F5F0E1',
            boxShadow: '0 0 18px rgba(245,240,225,0.2)',
            backdropFilter: 'blur(10px)'
          }} whileHover={{
            scale: 1.02,
            boxShadow: '0 0 28px rgba(245,240,225,0.4)'
          }} whileTap={{
            scale: 0.97
          }} data-id="element-482">
                <span aria-hidden="true" data-id="element-483">←</span>
                <span className="hidden sm:inline" data-id="element-484">
                  Volver a Tus documentos privados
                </span>
                <span className="sm:hidden" data-id="element-485">Volver</span>
              </motion.button>}
          </AnimatePresence>

          <Link to="/portal-de-usuario" className="group relative inline-flex items-center gap-2 px-4 md:px-5 py-2 md:py-2.5 rounded-full font-serif font-semibold text-[11px] md:text-xs tracking-[0.2em] uppercase transition-all duration-300 flex-shrink-0" style={{
          background: 'linear-gradient(135deg, #C9A84C 0%, #E8D48B 100%)',
          color: '#050508',
          boxShadow: '0 0 14px rgba(201,168,76,0.35)'
        }} data-id="element-486">
            <span className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{
            boxShadow: '0 0 24px rgba(232,212,139,0.85), 0 0 40px rgba(201,168,76,0.45)'
          }} aria-hidden="true" data-id="element-487" />
            <span className="relative whitespace-nowrap" data-id="element-488">
              Portal de Usuario
            </span>
          </Link>
        </div>
      </div>
    </motion.nav>;
}